
import { Vue, Component, Prop } from "vue-property-decorator";
import DrawOverlaysPGIS from "../../DrawOverlays/pgis/DrawOverlaysPGIS";
import PolylineRangingPGIS from "../../Ranging/pgis/PolylineRanging";
import WidgetsManagerPGIS from "./WidgetsManagerPGIS";
@Component
export default class Measurement extends Vue {
  @Prop({ type: Object }) map!: any;

  private menuList: string[] = ["标记", "测距", "测面", "删除", "搜索"];
  private menuIndex: number = -1;
  private uuids: string[] = [];

  private menuFn(ind: number) {
    if (ind == 3) {
      this.menuIndex = -1;
    } else {
      this.menuIndex = ind;
    }
    if (ind == 4) {
      let tool = WidgetsManagerPGIS.getInstance(this.map);
      tool.toggleWidget(["search"]);
      this.measureTool("clear");
    } else if (ind == 3) {
      this.measureTool("clear");
    } else if (ind == 2) {
      this.measureTool("area");
    } else if (ind == 1) {
      this.measureTool("line");
    } else if (ind == 0) {
      this.addPoint();
    }
  }
  private async addPoint() {
    let draw = DrawOverlaysPGIS.getInstance(this.map, this.map.fmap);
    const results = draw.startDrawOverlays({
      defaultSymbol: {
        url: "assets/styles/img/marker.png",
        size: [32, 32],
      },
      drawType: "point",
      generateId: true,
      type: "markPoint",
      clearLastResult: false,
      callback: false,
      onlyOnce: true,
    });
  }
  private async measureTool(type: string) {
    const polylineRanging = PolylineRangingPGIS.getInstance(
      this.map,
      this.map.fmap
    );
    const draw = DrawOverlaysPGIS.getInstance(this.map, this.map.fmap);
    if (type == "line") {
      polylineRanging.polylineRanging({ type: "line" });
    } else if (type == "area") {
      polylineRanging.polylineRanging({ type: "area" });
    } else if (type == "clear") {
      polylineRanging.clearRangingResults();
      draw.deleteDrawOverlays({ types: ["markPoint"] });
    }
  }
}
